/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DestroyRevision
 */
export interface DestroyRevision {
  /**
   * Provide revision number as verification
   */
  number: number;
}

/**
 * Check if a given object implements the DestroyRevision interface.
 */
export function instanceOfDestroyRevision(value: object): value is DestroyRevision {
  if (!("number" in value) || value["number"] === undefined) return false;
  return true;
}

export function DestroyRevisionFromJSON(json: any): DestroyRevision {
  return DestroyRevisionFromJSONTyped(json, false);
}

export function DestroyRevisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DestroyRevision {
  if (json == null) {
    return json;
  }
  return {
    number: json["number"],
  };
}

export function DestroyRevisionToJSON(json: any): DestroyRevision {
  return DestroyRevisionToJSONTyped(json, false);
}

export function DestroyRevisionToJSONTyped(
  value?: DestroyRevision | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    number: value["number"],
  };
}
